import { logEventWithGroups } from '@cultureamp/amplitude';

require('./shared/textarea-shims');
var t = require('./shared/translations');
var updateQueryStringParameter = require('./shared/url-helper');
require('./shared/cookies-helper');
require('./survey/configure.js');
require('./focus-helpers');
require('./validation-helpers');
require('select2');
require('ca-appamp-assets/javascripts/resize');
require('./questions/question');
require('jquery-ui');
var request = require('ca-request').default;
var requestErrorHandler = require('ca-request/requestErrorHandler').default;
var notifyError = require('ca-error-handler/notifyError').default;

import React from 'react';
import { createRoot } from 'react-dom/client';

import UnansweredMandatoryQuestionsModal from 'ca-capture/UnansweredMandatoryQuestionsModal/UnansweredMandatoryQuestionsModal';
import Submission from 'ca-capture/Submission/Submission';
import { SubmissionFinalizeDOMWrapper } from 'ca-capture/SubmissionFinalize/SubmissionFinalize';
import 'ca-dom-binding';
import {
  SubmissionFailedError,
  UnansweredMandatoryQuestionsError,
} from 'ca-capture/SubmissionFinalize/errors';

// For capture, we don't want the default error handling behaviour
// instead just wrap failed requests with a RequestError
function wrapJQueryRequest(req) {
  return Promise.resolve(req).catch(function (xhr) {
    return Promise.reject(new request.RequestError(xhr));
  });
}

// Taken from: http://stackoverflow.com/questions/7748617/jquery-easing-easeoutcubic-emphasizing-on-the-ease
// This is part of JQuery UI, which isn't included in the response controller
$.easing.easeOutCubic = function (x, t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
};
$.easing.easeInCubic = function (t, b, c, d) {
  t /= d;
  return c * t * t * t + b;
};

var ua = navigator.userAgent.toLowerCase();
var isLegacyAndroid = /android 2/i.test(ua);
var isLegacyBrowser = !$.support.cssFloat; // Sub IE9
var unQuestions;
var totalQuestions;

var $document = $(document);

$document.on(
  'click.dialog',
  'body#responses.confidentiality_template_content button.submit',
  function (e) {
    window.close();
  }
);

// COMMS FRAMEWORK: If the locale select is changed, reload the page with the given locale
$document.on('change', 'section.locale select', function (e) {
  window.location.search = 'welcome=false&locale=' + $(this).val();
});

// -- Document Ready. Trigger dialogs and attach handlers
$(function () {
  unQuestions = $(
    '#accordion .question:not(.answered):not(.no-options):not(.not-required)'
  ).length;
  totalQuestions = $(
    '#accordion .question:not(.no-options):not(.not-required)'
  ).length;

  // Initialise the 'x of x questions answered' label in the .finish section
  $('.partial_answered .answered_amount').text(totalQuestions - unQuestions);
  $('.partial_answered .total_questions').text(totalQuestions);

  // Initialise theme/sections counters
  updateThemeCounters();

  // COMMS FRAMEWORK: If a locale flag is clicked, reload the page with the given locale
  $document.on('click', 'section.locale a', function (e) {
    e.preventDefault();
    var $this = $(this);
    window.location.search = '&locale=' + $this.data('locale');
    return false;
  });

  // TOPBAR: If a locale is selected from the top bar menu, reload the page with the given locale
  $document.on('click', '.locale__list-item', function (e) {
    e.preventDefault();
    var $this = $(this);
    var uri = window.location.toString();
    uri = updateQueryStringParameter(uri, 'welcome', 'true');
    uri = updateQueryStringParameter(uri, 'locale', $this.data('locale'));
    window.location = uri;
    return false;
  });

  // Navigate down to the first unanswered theme (unless the first unanswered is the first theme!)
  var firstUnansweredTheme = $('.question:not(.answered)')
    .eq(0)
    .closest('.theme')
    .attr('data-index');
  if (firstUnansweredTheme > 0) {
    selectTheme(firstUnansweredTheme, false);
  }

  // Trigger data elements to remember their values up-front
  $('input, textarea').trigger('remember');

  // Ensure `active` theme opens on page load
  var $firstSelectedTheme = $('.theme.selected').find('div.details');
  var $firstSelectedThemeButton = $('.theme.selected').find(
    'button[data-theme-button]'
  );

  $firstSelectedTheme.slideDown('slow', function () {
    // Failsafe to ensure `active` accordion opens
    $firstSelectedTheme.css('display', 'block');

    $firstSelectedThemeButton.attr({
      'aria-expanded': true,
    });
  });
});

// Message Alert Links
$document.on('click', 'a.message', function (e) {
  e.preventDefault();
  var message = $(this).data('message');
  if (typeof message !== 'undefined') {
    window.alert(message);
  }
  return false;
});

// -- Navigation
// Next Button - coming from React now
// This can port over to React once the accordion has been moved

$(function () {
  $(document).on('reactNextButton', function (event, data) {
    $(
      `#accordion .theme[data-index=${data.index}] [data-theme-button]`
    ).focus();
    selectTheme(data.index, true);
  });
});

// Clicking on a Theme Directly
$(function () {
  $('.theme__header-wrapper').on('click', function (e) {
    var $theme = $(this).closest('.theme');
    if ($theme.hasClass('selected')) {
      const $details = $theme.find('div.details');
      const $button = $theme.find('button.theme__header-wrapper');
      $theme.removeClass('selected');
      $button.attr('aria-expanded', false);
      $details.slideUp(500, 'easeOutCubic');
      return;
    }
    selectTheme($theme.attr('data-index'), false);
  });
});

// -- All Question Types & Generic Question Widgets
// Mark question as answered (invoke by triggering 'answered' on the question)
$document.on('answered', '.question', function (e) {
  var $this = $(this);
  markAsAnswered($this);
  promptNextQuestionInTheme($this);
  updateThemeStatus($this);
});

$document.on('unanswered', '.question', function (e) {
  var $this = $(this);
  markAsAnswered($this, false);
  updateThemeStatus($this);
});

/**
 * Listen for a custom event that will be sent via the RatingScale.js React component.
 * This small pieces of functionality were not able to be moved over yet.
 * (If the accordion moves into React, then we can move these over)
 */
$(document).on('reactRatingSave', function (event, data) {
  const $container = $(data.container);

  // mark the question as unanswered, unless we are answering it
  $container
    .closest('.question')
    .trigger(data.value === '' ? 'unanswered' : 'answered');

  promptNextQuestionInTheme($container);
});

$(document).on('reactAnswerChange', function (event, data) {
  $(data.container)
    .closest('.question')
    .trigger('submitting', data.answered)
    .trigger(data.answered ? 'answered' : 'unanswered');
  // ^the two triggers above need to be in the order specified, otherwise timing of things will cause bugs.
});

// Asynchronously save comments
$(function () {
  $('#main-content .comment textarea').on('change', function (e) {
    var $input = $(this);
    var $form = $input.closest('form');
    $input.trigger('submitting');

    var answerUrl = $form.attr('action');
    wrapJQueryRequest(
      $.ajax(answerUrl, {
        type: $form.attr('method'),
        data: $form.serialize(),
        error: function (xhr, ajaxOptions, thrownError) {
          alertUser(thrownError);
          $input.val($input.attr('data-original'));
          $form.find('input[type="checkbox"]').each(function () {
            $(this).attr('checked', $(this).attr('data-original') == 'true');
          });
        },
        success: function (response) {
          $input.attr('data-original', $input.val());
          $form.find('input[type="checkbox"]').each(function () {
            $(this).attr('data-original', $(this).attr('checked'));
          });
        },
      })
    ).catch(function (err) {
      requestErrorHandler(
        err,
        { answerUrl: answerUrl },
        'segment/freetext answer request'
      );
    });
    markAsAnswered($input, $input.val().length > 0);
    promptNextQuestionInTheme($input);
    updateThemeStatus($input);
  });
  $('#main-content .comment input').on('change', function (e) {
    $('#main-content .comment textarea').trigger('change');
  });
});

// -- Submit Response
// Warn if not all mandatory questions have been answered before submitting

var navigateUnanswered = function () {
  const $firstUnansweredQuestion = $('.question:not(.answered)').eq(0);
  const $firstUnansweredTheme = $firstUnansweredQuestion.closest('.theme');

  selectTheme($firstUnansweredTheme.attr('data-index'), false).done(() => {
    unansweredScroll($firstUnansweredQuestion);
  });
};

var mandatoryQuestions = function () {
  return $('.question.mandatory');
};

var mandatoryQuestionIds = function () {
  const elements = document.querySelectorAll('.question.mandatory');
  let questionIds = [];
  elements.forEach(function (element) {
    questionIds.push(element.getAttribute('data-question-id'));
  });
  return questionIds;
};

var unansweredMandatoryQuestionIds = function () {
  const elements = document.querySelectorAll(
    '.question.mandatory:not(.answered)'
  );
  let questionIds = [];
  elements.forEach(function (element) {
    questionIds.push(element.getAttribute('data-question-id'));
  });
  return questionIds;
};

var unansweredMandatoryQuestions = function () {
  return mandatoryQuestions().filter(':not(.answered)');
};

var navigateUnansweredMandatory = function () {
  const $firstUnansweredQuestion = unansweredMandatoryQuestions().eq(0);
  const $firstUnansweredTheme = $firstUnansweredQuestion.closest('.theme');
  selectTheme($firstUnansweredTheme.attr('data-index'), false).done(() => {
    unansweredScroll($firstUnansweredQuestion);
  });
};

var submitResponse = async function () {
  return await Submission.finalize(async () => {
    // This finalize function will not always be executed immediately. If the Submission
    // has multiple activities still enqueued, they will be processed first, before this
    // function. If any one of thoese activities fail, they may result in questions being
    // reset to an un-answered state. Because of this, we need to re-run all the checks
    // that are done upon first clicking the "submit" button.
    var unansweredMandatory =
      $(
        '.question.mandatory:not(.no-options):not(.not-required):not(.answered)'
      ).length > 0;

    if (unansweredMandatory) {
      throw new UnansweredMandatoryQuestionsError();
    }

    const requestUrl = $('form#finish').attr('action');
    try {
      await logSurveyCaptured().finally(async () => {
        const response = await request.put(requestUrl, {
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ field: 'submit' }), // required body to submit the response
          redirect: 'manual',
        });
        const { redirect_url } = await response.json();
        window.location.assign(redirect_url);
      });
    } catch {
      throw new SubmissionFailedError();
    }
  });
};

var doCheckAndSubmit = function () {
  // When the finish button is pressed, check if all questions are answered. If not,
  // prompt the user to confirm the action

  var unansweredMandatory =
    $('.question.mandatory:not(.no-options):not(.not-required):not(.answered)')
      .length > 0;

  if (unansweredMandatory) {
    presentMandatoryModal();
  } else {
    presentConfirmationModal();
  }
};

// Handler for the form that wraps the capture submit button
const onFormSubmit = (e) => {
  e.preventDefault();
  doCheckAndSubmit();
};

$(function () {
  $('#finish').on('submit', onFormSubmit);
});

function logSurveyCaptured() {
  const amplitudeNode = document.querySelector('[data-amplitude]');
  const urlParams = new URLSearchParams(window.location.search);
  const questions = document.querySelectorAll('.question');
  const unansweredQuestions = document.querySelectorAll(
    '.question:not(.answered)'
  );
  const themes = document.querySelectorAll('.theme');
  const ratingComments = document.querySelectorAll(
    '[name="rating-comment-value"]'
  );
  const freeTextComments = document.querySelectorAll(
    '.question.answered.free-text'
  );
  return logEventWithGroups(
    'Survey Response Captured (Submission)',
    {
      'Comments added': ratingComments.length + freeTextComments.length,
      'Questions complete': questions.length - unansweredQuestions.length,
      'Questions set': questions.length,
      Source: urlParams.get('utm_source'),
      'Response ID': amplitudeNode
        ? amplitudeNode.getAttribute('data-amplitude-response-id')
        : null,
      'Themes set': themes.length,
    },
    {
      Survey: amplitudeNode
        ? amplitudeNode.getAttribute('data-amplitude-survey-id')
        : null,
    }
  );
}

var setSubmissionFinalizeProps = () => {};
function registerSetSubmissionFinalizeProps(callback) {
  setSubmissionFinalizeProps = callback;
}

const submitDialogRootContainer = document.getElementById('submit-dialog-root');

if (submitDialogRootContainer) {
  const root = createRoot(submitDialogRootContainer);
  root.render(
    React.createElement(
      SubmissionFinalizeDOMWrapper,
      {
        registerPropsSetterCallback: registerSetSubmissionFinalizeProps,
        initialProps: {
          isOpen: false,
          onSubmit: submitResponse,
          onDismiss: () => {
            navigateUnanswered();
            setSubmissionFinalizeProps({ isOpen: false });
          },
          onUnansweredMandatoryQuestionsError: () => {
            presentMandatoryModal();
            setSubmissionFinalizeProps({ isOpen: false });
          },
          onErrorDismiss: () => {
            setSubmissionFinalizeProps({ isOpen: false });
          },
          uiText: {
            finalizeHeader:
              submitDialogRootContainer.dataset.uiTextFinalizeHeader,
            finalizeSubHeader:
              submitDialogRootContainer.dataset.uiTextFinalizeSubHeader,
            finalizeContent:
              submitDialogRootContainer.dataset.uiTextFinalizeContent,
            finalizeDismissLabel:
              submitDialogRootContainer.dataset.uiTextFinalizeDismissLabel,
            finalizeConfirmLabel:
              submitDialogRootContainer.dataset.uiTextFinalizeConfirmLabel,
            finalizeConfirmWorkingLabel:
              submitDialogRootContainer.dataset
                .uiTextFinalizeConfirmWorkingLabel,
            finalizeNotificationTitle:
              submitDialogRootContainer.dataset.uiTextFinalizeNotificationTitle,
            finalizeNotificationContent:
              submitDialogRootContainer.dataset
                .uiTextFinalizeNotificationContent,
            errorHeader: submitDialogRootContainer.dataset.uiTextErrorHeader,
            errorContent: submitDialogRootContainer.dataset.uiTextErrorContent,
            errorDismissLabel:
              submitDialogRootContainer.dataset.uiTextErrorDismissLabel,
          },
        },
      },
      null
    )
  );
}

function presentConfirmationModal() {
  setSubmissionFinalizeProps({
    isOpen: true,
  });
}

function presentMandatoryModal() {
  const unansweredIds = unansweredMandatoryQuestionIds();

  // Send a custom event for our React components to listen and... react to
  $(document).trigger('promptUnanswered', [unansweredIds]);

  const container = document.getElementById(
    'unanswered-mandatory-questions-modal-root'
  );

  const root = createRoot(container);
  root.render(
    React.createElement(
      UnansweredMandatoryQuestionsModal,
      {
        uiText: {
          close: container.dataset.unansweredMandatoryQuestionsModalClose,
          confirmMultiple:
            container.dataset.unansweredMandatoryQuestionsModalConfirmMultiple,
          confirmSingle:
            container.dataset.unansweredMandatoryQuestionsModalConfirmSingle,
          confirmShort:
            container.dataset.unansweredMandatoryQuestionsModalConfirmShort,
          description:
            container.dataset.unansweredMandatoryQuestionsModalDescription,
          titleLong:
            container.dataset.unansweredMandatoryQuestionsModalTitleLong,
          titleShort:
            container.dataset.unansweredMandatoryQuestionsModalTitleShort,
        },
        unansweredCount: unansweredMandatoryQuestions().size(),
        onDismiss: (wasConfirmed) => {
          root.unmount();

          if (wasConfirmed) {
            navigateUnansweredMandatory();
          }
        },
      },
      null
    )
  );
}

function unansweredScroll($focusToContainer) {
  var scrollSelect = isLegacyAndroid ? 'body' : 'html, body';
  var $scroll = $(scrollSelect);

  // Logs unexplained error with extra debugging information
  // Refer to https://trello.com/c/W4UDFpp0
  if (typeof $focusToContainer.offset() === 'undefined') {
    notifyError(new Error('$focusToContainer.offset() is undefined'), {
      $focusToContainer: $focusToContainer,
    });
  }

  var top =
    $focusToContainer.offset().top -
    $('.top-bar').height() -
    $('.splash-screen__top-banner').height() -
    20;

  const focusFirstError = () => {
    $focusToContainer
      .find('[data-focus-to-on-navigate=true]')
      .eq(0)
      .trigger('focus');
  };

  if (isLegacyAndroid) {
    $scroll.scrollTop(top);
    focusFirstError();
  } else {
    $scroll.animate({ scrollTop: top }, 500, 'easeOutCubic', () => {
      // This must happen after the scroll has finished in order for the combobox list to show
      focusFirstError();
    });
  }
}

function scrollToTheme(newTheme, includeHeight = false) {
  var scrollSelect = isLegacyAndroid ? 'body' : 'html, body';
  var $scroll = $(scrollSelect);

  var top = newTheme.offset().top;

  // Now go forth and scroll
  if (isLegacyAndroid) {
    $scroll.scrollTop(top);
    return $.Deferred().resolve();
  } else {
    var scrollPadding = 20;
    var withThemeHeight = includeHeight
      ? newTheme.find('.theme__header-wrapper').height()
      : 0;
    var topAdjusted =
      top -
      $('.splash-screen__top-banner').height() -
      $('.top-bar').height() +
      withThemeHeight;

    topAdjusted -= scrollPadding;
    return $scroll
      .animate({ scrollTop: topAdjusted }, 500, 'easeOutCubic')
      .promise();
  }
}

function selectTheme(index, shouldScroll) {
  var oldTheme = $('#accordion .theme.selected');
  var newTheme;
  var promise = $.Deferred().resolve();

  // skip themes that are invisible because all of the questions inside are
  // hidden (e.g., because they depend on an unselected previous answer)
  do {
    newTheme = $('#accordion .theme[data-index=' + index + ']');
    index++;
  } while (newTheme.hasClass('empty'));

  const oldAndNewAreDifferent =
    newTheme.attr('data-index') !== oldTheme.attr('data-index');

  if (oldTheme.length > 0 && oldAndNewAreDifferent) {
    oldTheme.removeClass('selected');
    oldTheme
      .find('button[data-theme-button]')
      .attr('aria-expanded', false)
      .removeAttr('aria-disabled');
    promise = oldTheme
      .find('div.details')
      .slideUp(500, 'easeOutCubic')
      .promise();
    if (
      shouldScroll ||
      newTheme.attr('data-index') > oldTheme.attr('data-index')
    ) {
      promise = scrollToTheme(oldTheme, true);
    }
  }

  if (newTheme.length > 0) {
    if (oldAndNewAreDifferent) {
      promise = openCollapsible(newTheme).promise();
    }

    // only scroll if NEXT was clicked, not if theme selected directly, or if new theme is beneath oldtheme
    if (
      shouldScroll ||
      newTheme.attr('data-index') > oldTheme.attr('data-index')
    ) {
      promise.done(() => {
        promise = scrollToTheme(newTheme);
      });
    }
  }

  return promise;
}

function openCollapsible($theme) {
  $theme.addClass('selected');
  $theme.find('button[data-theme-button]').attr({
    'aria-expanded': true,
  });
  return $theme
    .find('div.details')
    .removeAttr('style')
    .slideDown(500, 'easeOutCubic')
    .promise();
}

function alertUser(thrownError, errorMessageKey) {
  if (thrownError == 'Forbidden') {
    alert(t('response.already_submitted'));
  } else {
    var genericNetworkErrorMessage = t('response.network_error');
    if (errorMessageKey) {
      alert(t(errorMessageKey, { defaultValue: genericNetworkErrorMessage }));
    } else {
      alert(genericNetworkErrorMessage);
    }
  }
}

function promptNextQuestionInTheme(element) {
  var $theme = $(element).closest('.theme');
  $theme.find('.question.prompted').removeClass('prompted');
  $theme.find('.question:not(.answered)').eq(0).addClass('prompted');
}

function themeQuestionsAnswered(theme) {
  return theme.find('.question.answered:not(.not-required)').length;
}

function themeQuestionsLeft(theme) {
  var totalQuestions = theme.attr('data-questions');
  var totalAnswered = themeQuestionsAnswered(theme);
  return totalQuestions - totalAnswered;
}

function markAsAnswered(element, isIncrement) {
  if (isIncrement == undefined) {
    isIncrement = true;
  }
  var question = $(element).closest('.question');
  question.toggleClass('answered', isIncrement);
  question.removeClass('selected');

  // Update theme answer count
  var theme = $(element).closest('.theme');
  theme.find('span.answered').text(themeQuestionsLeft(theme));

  var unQuestions = $(
    '#accordion .question:not(.answered):not(.no-options):not(.not-required)'
  ).length;
  var surveyComplete = unQuestions == 0;

  totalQuestions = $(
    '#accordion .question:not(.no-options):not(.not-required)'
  ).length;

  $('.partial_answered .answered_amount').text(totalQuestions - unQuestions);
  $('.partial_answered .total_questions').text(totalQuestions);

  $('ol.survey')
    .toggleClass('answered', surveyComplete)
    .toggleClass('partial', !surveyComplete);

  // Remove mandatory unanswered alert
  if (isIncrement == true) {
    $(element).removeClass('alert-error');
  }
  updateThemeCounters();
}

function updateThemeCounters() {
  $('.theme').map(function (index, theme) {
    $(theme)
      .find('span.answered')
      .text(themeQuestionsLeft($(theme)));
  });
}

function updateThemeStatus(element) {
  var theme = $(element).closest('.theme');
  var totalAnswered = themeQuestionsAnswered(theme);
  var totalQuestions = theme.attr('data-questions');

  var select = 'all';
  if (totalAnswered < totalQuestions) select = 'partial';
  if (totalAnswered == 0) select = 'none';
  theme.removeClass('all partial none').addClass(select);
}

function renderLocaleSelectOption(option) {
  return `<span class="locale-label">${option.text}</span>`;
}

$(function () {
  var selectEl = '.capture-locale__select select';

  $(selectEl).select2({
    minimumResultsForSearch: Infinity,
    formatResult: renderLocaleSelectOption,
    formatSelection: renderLocaleSelectOption,
    dropdownCssClass: 'capture-locale__select',
  });

  $document.on('change', selectEl, function () {
    var hasSeenCaptureWelcome = window.location.search.includes('welcome=true');

    window.location.search =
      'welcome=' + hasSeenCaptureWelcome + '&locale=' + $(this).val();
  });
});
